import React from 'react';
import { func, number, object, string } from 'prop-types';

import HealthRecordDate from '../HealthRecordDate';
import HealthRecordActions from '../HealthRecordActions';

import s from './HealthRecordListItem.css';
import HealthRecordNotes from '../HealthRecordNotes/HealthRecordNotes';


/*
  POR-371 - dropped displaying format and from.
*/
const HealthRecordListItem = ({ ...props }) =>
  <article className={s.component}>
    <div className={s.container}>
      <HealthRecordDate time={props.time} />
      <HealthRecordActions
        id={props.id}
        format={props.format}
        handleTransmitForm={props.handleTransmitForm}
        selectedHealthRecordListItem={props.selectedHealthRecordListItem}
        handleViewRecord={props.handleViewRecord}
      />
      <HealthRecordNotes
        className={s.notes}
        id={`${props.id}__notes`}
        notes={props.messageText}
        truncateLength={300}
      />
    </div>
  </article>;

HealthRecordListItem.propTypes = {
  format: string,
  from: string,
  id: number,
  handleTransmitForm: func,
  handleViewRecord: func,
  selectedHealthRecordListItem: object,
  messageText: string,
  time: number,
};

export default HealthRecordListItem;



// WEBPACK FOOTER //
// ./src/components/Pages/Health/HealthRecordListItem/HealthRecordListItem.js